import { OtpResendModel } from './otp-resend.model';

export class OtpValidationModel extends OtpResendModel {
  otp: string | null = null;

  constructor() {
    super();
  }
}
